<template>
  <div />
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import useApi from '@/shared/composables/useApi';

const { api } = useApi();
const { locale } = useI18n();
const router = useRouter();
const store = useStore();

onMounted(signOut);

async function signOut() {
  await api.member.session.promiseDestroy();

  if (store.state.profile?.is_parent) store.commit('setAuthenticated', false);
  store.commit('setProfile', null);

  const query = {};
  if (locale.value) query.lang = locale.value;
  void router.replace({ path: '/', query });
}
</script>
